import type { UseUserReturn } from "@clerk/types";

export const isEmployeeUser = (user: UseUserReturn["user"]) =>
	user?.primaryEmailAddress?.emailAddress.endsWith("@brookbushinstitute.com") &&
	process.env.NODE_ENV !== "development";
